import { createFileRoute } from '@tanstack/react-router';

import { LoginForm } from '@/features/auth/components/login-form';

export interface LoginSearch {
  redirect?: string;
}

export const Route = createFileRoute('/_public/login')({
  validateSearch: (search: Record<string, unknown>): LoginSearch => {
    return {
      redirect: typeof search.redirect === 'string' ? search.redirect : undefined,
    };
  },
  component: LoginPage,
});

function LoginPage() {
  const { redirect } = Route.useSearch();

  return <LoginForm redirectTo={redirect} />;
}
